import dayjs from 'dayjs';

/**
 * The Actions meetings tab's agenda ranges, and how a link that names one
 * meeting picks the range that contains it. Today's and tomorrow's meetings
 * get their own day; anything else within the next week lands on the 7-day
 * view; a meeting outside that is left to the tab's default (today), where the
 * agenda falls back to its own selection.
 */
export type MeetingsRangeKey = 'today' | 'tomorrow' | 'week';

const MEETINGS_RANGE_KEYS: MeetingsRangeKey[] = ['today', 'tomorrow', 'week'];

export const parseMeetingsRange = (value: string | null | undefined): MeetingsRangeKey | null =>
  (MEETINGS_RANGE_KEYS as string[]).includes(value ?? '') ? (value as MeetingsRangeKey) : null;

export const meetingsRangeFor = (startAt: string | null | undefined): MeetingsRangeKey | null => {
  if (!startAt) return null;
  const start = dayjs(startAt);
  if (!start.isValid()) return null;
  const days = start.startOf('day').diff(dayjs().startOf('day'), 'day');
  if (days === 0) return 'today';
  if (days === 1) return 'tomorrow';
  if (days > 1 && days <= 6) return 'week';
  return null;
};
